/**
 * Quién opera AcademIA, en UN solo lugar: lo usan los Términos, la Política de Privacidad y
 * (el nombre) el JSON-LD de la home. El copyright del footer NO lo toma de acá: está escrito
 * a mano en `landing.footerNew.copyright` (locales/es/translation.json) — si cambia el nombre,
 * cambialo también ahí.
 *
 * Desde el 2026-10-07 AcademIA es una marca de la empresa, no de una persona: los textos
 * legales nombran a la LLC y nunca a Rodrigo (ni su CUIT ni su domicilio particular).
 *
 * Datos tal como figuran en Stripe Atlas. Lo que NO se publica, a propósito:
 * - la dirección comercial de la empresa (es un departamento particular) ni su teléfono;
 * - el EIN (todavía no está emitido; cuando llegue tampoco hace falta mostrarlo).
 * Como domicilio legal va el del agente registrado en Delaware.
 */
export const OPERATOR_LEGAL_NAME = "Kheprai, LLC";

/** Número de archivo (file number) de la sociedad en la Division of Corporations de Delaware. */
export const OPERATOR_DELAWARE_FILE_NUMBER = "10790063";

export const OPERATOR_REGISTERED_AGENT = "Legalinc Corporate Services Inc.";

/** Domicilio del agente registrado: es el domicilio legal que se publica. */
export const OPERATOR_LEGAL_ADDRESS = "131 Continental Dr, Suite 305, Newark, DE 19713, EE. UU.";
